import { NumberFieldModel } from "../../common/commonForms";

export function calculateExcessAmount(
  subscribers: {
    debtContributionTotalReceivableField: NumberFieldModel;
    debtContributionMaxAmountToBeConvertedField: NumberFieldModel;
  }[],
): number {
  return subscribers
    .map(
      (d) =>
        d.debtContributionTotalReceivableField.toNumberOrZero() -
        d.debtContributionMaxAmountToBeConvertedField.toNumberOrZero(),
    )
    .reduce((accum: number, n: number) => accum + n, 0);
}
